import angular from "angular";
import _ from "underscore";
import resolve from "ioc/resolve";
import { extendModule } from "ng";
import servicestack from "servicestack/_servicestack.app";
import webutils from "webutils/app";
import webforms from "webforms/app";
//import uiBootstrap from 'angular-ui-bootstrap';
import webmodals from "webmodals/_webmodals.app";
import $session from "servicestack/session";
import addressFieldset from "emun.auth/address-fieldset";
import logout from "emun.auth/logout.directive";
import login from "emun.auth/login";
import loginPrompt from "emun.auth/login-prompt.directive";
import loginFieldset from "emun.auth/login-fieldset";
import changePasswordPrompt from "emun.auth/change-password/change-password-prompt.directive";
import resetPasswordPrompt from "emun.auth/reset-password/reset-password-prompt.directive";
import registerConsumerFieldset from "emun.auth/register-consumer-fieldset";
import registerRetailerFieldset from "emun.auth/register-retailer-fieldset";
import resetPasswordFieldset from "emun.auth/reset-password/reset-password-fieldset";
import resetPassword from "emun.auth/reset-password/reset-password";
import changePasswordFieldset from "emun.auth/change-password/change-password-fieldset";
import changePassword from "emun.auth/change-password/change-password";
import forgotPassword from "emun.auth/forgot-password/forgot-password";
import companyInfoFieldset from "emun.auth/company-info-fieldset";
import contactInfoFieldset from "emun.auth/contact-info-fieldset";
import tradeReferenceFieldset from "emun.auth/trade-reference-fieldset";
import bankReferenceFieldset from "emun.auth/bank-reference-fieldset";
import registerRetailer from "emun.auth/register-retailer";
import registerConsumer from "emun.auth/register-consumer";
import retailerApproval from "emun.auth/retailer-approval";
import registerConsumerPrompt from "emun.auth/register-consumer-prompt.directive";
import registerRetailerPrompt from "emun.auth/register-retailer-prompt.directive";
import registerRetailerPromptForm from "emun.auth/register-retailer.prompt.directive";
import registerConsumerPromptForm from "emun.auth/register-consumer.prompt.directive";
import registerCurrentAccountPrompt from "emun.auth/register-current-acct-prompt.directive";
import registerCurrentAccount from "emun.auth/register-current-acct";
import registerConfirmation from "emun.auth/register-confirmation";
import registerAuthPrompt from "emun.auth/auth-prompt";
import registerUserModule from "emun.auth/users/_register";
import permissionsModule from "emun.auth/permissions/permissions.module";
import usergroupsModule from "emun.auth/usergroups/usergroups.module";
import recaptchaModule from "emun.auth/recaptcha/recaptcha.module";
import cookieConsentModule from "emun.auth/cookie-consent/cookie-consent.module";
import adminModule from "emun.admin/admin.module";
import verifyEmail from "emun.auth/verify-email";
import verifyEmailSimple from "emun.auth/verify-email-simple";
import verifyEmailTin from "emun.auth/verify-email-tin";

export const IS_TEST = (ENV_TAGS || []).indexOf("Test") >= 0;

const deps = [
  "views",
  webutils,
  webforms,
  webmodals,
  "angular-growl",
  "infinite-scroll",
  servicestack,
  "ui.router",
];

function Run($state, $stateParams, $rootScope, $q, $timeout, $cart) {
  const states = [];
  const getNavMemo = {};
  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
  $rootScope.$on(
    "$stateChangeStart",
    function (event, toState, toParams, fromState, fromParams) {
      if (toState.name === "noop") {
        event.preventDefault();
      }
    }
  );
  if (IS_TEST) {
    $rootScope.$on(
      "$stateChangeError",
      (event, toState, toParams, fromState, fromParams, error) =>
        console.error("$stateChangeError", fromState.name, toState.name, {
          event,
          toState,
          toParams,
          fromState,
          fromParams,
        })
    );
    $rootScope.$on(
      "$stateChangeStart",
      (event, toState, toParams, fromState, fromParams) =>
        console.info("$stateChangeStart", fromState.name, toState.name, {
          event,
          toState,
          toParams,
          fromState,
          fromParams,
        })
    );
    $rootScope.$on(
      "$stateChangeSuccess",
      (event, toState, toParams, fromState, fromParams) => {
        Object.assign($state, { fromState, fromParams });
        console.debug("$stateChangeSuccess", fromState.name, toState.name, {
          event,
          toState,
          toParams,
          fromState,
          fromParams,
        });
      }
    );
    $rootScope.$on(
      "$locationChangeStart",
      console.info.bind(console, "$locationChangeStart")
    );
    $rootScope.$on(
      "$locationChangeSuccess",
      console.info.bind(console, "$locationChangeSuccess")
    );
  }

  $state.startsWith = (p) => {
    if (!states.length) {
      states.push(...$state.get());
    }
    return states.filter((c) => c.name.indexOf(p) === 0);
  };
  $state.getNav = (menu) => {
    if (!(menu in getNavMemo)) {
      if (!states.length) {
        states.push(...$state.get());
      }
      getNavMemo[menu] = states
        .filter((s) => $state.isVisible(s, menu))
        .sort((a, b) => a.nav - b.nav);
    }
    return getNavMemo[menu];
  };
  $state.isVisible = (state, menu) => {
    if ((state.nav || state.tab) && state.menu === menu) {
      if (angular.isFunction(state.authorize)) {
        var result = state.authorize($session, $state, $stateParams);
        if (!result) {
          return true;
        }
        //if (!result || !angular.isObject(result)) return true;
      } else {
        return true;
      }
    }
    return false;
  };

  // $state.get().forEach(s => {
  //   if (angular.isFunction(s.authorize)) s.authorize = _.memoize(s.authorize);
  // });

  $rootScope.$on("$stateChangeStart", (e, to, from) => {
    if (!angular.isFunction(to.authorize)) return;
    var result = to.authorize($session, $state, $stateParams, resolve);
    if (result) {
      $timeout(() => {
        if (angular.isString(result)) {
          if ($state.get(result)) $state.go(result);
          else window.location = "/";
        } else if (angular.isObject(result)) {
          for (var state in result) {
            if ($state.get(state)) $state.go(state, result[state]);
            else window.location = "/";
          }
        }
      });
    }
  });
}

var app = angular.module("emun.auth", deps);
registerAuthPrompt(app);
registerUserModule(app);
extendModule(
  app,
  permissionsModule,
  usergroupsModule,
  adminModule,
  recaptchaModule,
  cookieConsentModule
);

export default app
  .component("loginFieldset", loginFieldset)
  .component("login", login)
  .component("signIn", login)
  .directive("loginPrompt", loginPrompt)
  .directive("changePasswordPrompt", changePasswordPrompt)
  .directive("resetPasswordPrompt", resetPasswordPrompt)
  .directive("logout", logout)
  .component("addressFieldset", addressFieldset)
  .component("registerFieldset", registerConsumerFieldset)
  .component("registerConsumerFieldset", registerConsumerFieldset)
  .component("registerRetailerFieldset", registerRetailerFieldset)
  .component("companyInfoFieldset", companyInfoFieldset)
  .component("contactInfoFieldset", contactInfoFieldset)
  .component("resetPasswordFieldset", resetPasswordFieldset)
  .component("resetPassword", resetPassword)
  .component("changePasswordFieldset", changePasswordFieldset)
  .component("changePassword", changePassword)
  .component("forgotPassword", forgotPassword)
  .component("tradeReferenceFieldset", tradeReferenceFieldset)
  .component("bankReferenceFieldset", bankReferenceFieldset)
  .component("registerRetailer", registerRetailer)
  .component("registerConsumer", registerConsumer)
  .component("retailerApproval", retailerApproval)
  .directive("registerPrompt", registerConsumerPrompt)
  .directive("registerConsumerPrompt", registerConsumerPrompt)
  .directive("registerRetailerPrompt", registerRetailerPrompt)
  .directive("registerRetailerPromptForm", registerRetailerPromptForm)
  .directive("registerConsumerPromptForm", registerConsumerPromptForm)
  .directive("registerCurrentAcctPrompt", registerCurrentAccountPrompt)
  .directive("registerCurrentAccountPrompt", registerCurrentAccountPrompt)
  .component("registerCurrentAcct", registerCurrentAccount)
  .component("registerCurrentAccount", registerCurrentAccount)
  .component("verifyEmail", verifyEmail)
  .component("verifyEmailSimple", verifyEmailSimple)
  .component("verifyEmailTin", verifyEmailTin)
  .directive("registerConfirmation", registerConfirmation)
  .run(Run).name;
